import axios from "axios";

const initAxios = ({ baseURL, withCredentials, headers, ...options }) => {
  const instance = axios.create({
    baseURL,
    withCredentials: !!withCredentials,
    headers: headers || {
      Accept: "*/*",
      "Content-Type": "application/json",
    },
    ...options,
  });

  instance.interceptors.response.use(null, (error) => {
    console.log("intercept error", "error.response", error.response);

    return Promise.reject(error.response || error.request || error.message);
  });

  instance.source = axios.CancelToken.source;

  return instance;
};

export default initAxios;
